import React from 'react'
import clsx from 'clsx'
import {AccordionContext} from './AccordionContext'
import {Typography} from '../Typography'
import {Button} from '../Button'

const AccordionSummary = ({
  title,
  subtitle,
  disabled,
  className,
  icon,
  onClick,
}) => {
  const {expanded, toggle} = React.useContext(AccordionContext)

  const handleChange = event => {
    if (disabled) return
    if (toggle) {
      toggle(event)
    }
    if (onClick) {
      onClick(event)
    }
  }

  return (
    <div
      className={clsx('flex items-center flex-col lg:flex-row', className)}
      onClick={handleChange}
    >
      <div className={clsx('flex items-center mb-4')}>
        <div className="w-16 lg:flex lg:items-center lg:justify-center">
          <img src={icon} alt="" />
        </div>
        <div className="pl-4">
          <Typography className="uppercase" variant="heading2" color="blue-500">
            {title}
          </Typography>
        </div>
      </div>
      {subtitle && (
        <div className="lg:ml-auto">
          <Typography>{subtitle}</Typography>
        </div>
      )}
      {!subtitle && expanded && (
        <div className="lg:ml-auto">
          <Button
            background="bg-gray-900-to-500-y text-white"
            color="white"
            onClick={handleChange}
            className="uppercase"
          >
            Recolher
          </Button>
        </div>
      )}
      {!subtitle && !expanded && (
        <div className="lg:ml-auto">
          <Button
            background="bg-gray-100"
            color="white"
            onClick={handleChange}
            className="uppercase"
          >
            Expandir
          </Button>
        </div>
      )}
    </div>
  )
}

export {AccordionSummary}
